import React, { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Lock } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { ThemeToggle } from "@/components/ThemeToggle";

const inputCls = "w-full rounded-lg border border-[var(--border-subtle)] bg-[var(--bg-primary)] px-4 py-3 text-sm text-[var(--text-primary)] outline-none focus:border-[var(--accent-gold)]";

export const AdminLogin = () => {
  const { login } = useApp();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) toast.success(`Welcome back, ${res.user.name}.`);
    else { setError(res.error); toast.error(res.error); }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-[var(--bg-primary)] p-6" data-testid="admin-login-page">
      <div className="grid-bg absolute inset-0 opacity-20" />
      <div className="absolute right-5 top-5"><ThemeToggle /></div>
      <motion.form onSubmit={submit} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="arch-card relative w-full max-w-md p-8" data-testid="admin-login-form">
        <div className="flex h-11 w-11 items-center justify-center rounded-full" style={{ background: "linear-gradient(135deg,#9ED3B8,#0F4A36)" }}><Lock className="h-5 w-5 text-[#071711]" /></div>
        <div className="overline mt-6">Archedia Operating System</div>
        <h1 className="mt-2 font-serif text-3xl font-light text-[var(--text-primary)]">Admin sign in</h1>
        <div className="mt-6 space-y-4">
          <div><label className="mb-1.5 block text-sm font-medium text-[var(--text-primary)]">Email</label><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className={inputCls} autoComplete="username" /></div>
          <div><label className="mb-1.5 block text-sm font-medium text-[var(--text-primary)]">Password</label><input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className={inputCls} autoComplete="current-password" /></div>
          {error && <p className="text-sm text-red-500" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={busy} data-testid="login-submit" className="btn-gold w-full disabled:opacity-60">{busy ? "Signing in…" : "Sign In"} <ArrowRight className="h-4 w-4" /></button>
        </div>
      </motion.form>
    </div>
  );
};

export default AdminLogin;
